import {
  elapsed,
  JobStatus,
  QueuableRequestStatus,
  reduceToMap,
  type AuthUser,
} from '@cims-online/shared'
import type { QueuedBatchReportJobsQuery } from 'schema'
import type { GenericRequestFields } from '../../../../GenericQueue/components/GenericRequestCard/types'

export type QueuedBatchReportJob =
  QueuedBatchReportJobsQuery['listBatchReportJobs']['records'][number]

type PayItem = {
  globalId: string
  label: string
}

export type BatchReportQueueRequest = GenericRequestFields & {
  id: string
  reportIds: string[]
  payItems: Array<{ id: string; label: string }>
  dateRange: QueuedBatchReportJob['dateRange']
  progress: QueuedBatchReportJob['progress']
}

export function toQueuedBatchReportJob(
  job: QueuedBatchReportJob,
  user: AuthUser | null,
  payItems: PayItem[]
): BatchReportQueueRequest {
  const ownJob =
    user?.mail.toLowerCase() === job.createdUser.toLowerCase() ? user : null
  const statusId =
    job.statusId === JobStatus.Pending.id
      ? QueuableRequestStatus.Queued.id
      : QueuableRequestStatus.Generating.id
  const map = reduceToMap(payItems, 'globalId')
  return {
    id: job.id,
    statusId,
    createdDate: job.createdDate,
    startedDate: job.startedDate,
    estimatedString: elapsed({ milliseconds: job.initialEstimateMs }).formatted,
    requestedBy: {
      id: ownJob?.id ?? '',
      mail: ownJob?.mail ?? job.createdUser,
      displayName: ownJob?.displayName ?? null,
    },
    reportIds: job.reportIds,
    payItems: job.payItemIds.map((id) => ({
      id,
      label: map.get(id)?.label ?? id,
    })),
    dateRange: job.dateRange,
    progress: job.progress,
  }
}
